export const version = '11.8.2'
// Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.
